import { useTheme } from "@emotion/react"
import { Box, Text, theme } from "@pallet-hq/hegel"
import { FiCheck, FiX } from "react-icons/fi"
import React, { ReactNode } from "react"
import Tooltip from "components/Tooltip"

const CheckLabel = ({
    label = "",
    children,
    enabled = true,
    tooltipText,
    iconColor,
    textColor,
}: {
    label?: string | number
    children?: ReactNode
    enabled?: boolean
    tooltipText?: string
    iconColor?: string
    textColor?: string
}) => {
    // @ts-ignore
    const { colors } = useTheme()
    const Icon = enabled ? FiCheck : FiX
    const defaultIconColor = enabled ? colors.primary : theme.colors.gray500
    const defaultTextColor = enabled ? "gray900" : "gray500"
    return (
        <>
            <Box
                display="flex"
                gridGap="xsmall"
                alignItems="flex-start"
                data-tip={tooltipText ? tooltipText : undefined}
                data-offset={JSON.stringify({ left: 0, top: 4 })}
            >
                <Box display="flex" alignItems="center" justifyContent="center">
                    <Icon
                        size={theme.space.small}
                        stroke={iconColor ? iconColor : defaultIconColor}
                        strokeWidth={3}
                    />
                </Box>
                <Text
                    variant="paragraphMedium"
                    color={textColor ? textColor : defaultTextColor}
                >
                    {label}
                </Text>
                {children}
            </Box>
            <Tooltip
                effect="solid"
                arrowColor="transparent"
                scrollHide={true}
                css={{ maxWidth: "300px" }}
            />
        </>
    )
}
export default CheckLabel
